export default __webpack_public_path__ + "static/media/selected.29a2ad1e.svg";